var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"product"}},[_c('section',{staticClass:"section is-main"},[_c('div',{staticClass:"container box is-main"},[_c('div',{staticClass:"content"},[_c('h2',{staticClass:"title is-2"},[_vm._v("Sidan du sökte kunde inte hittas.")]),_c('p',[_vm._v(" Vänligen kontakta oss om du inte kan hitta vad du letar efter. ")])])])])])
}]

export { render, staticRenderFns }